<form [formGroup]="form">
  <h4 i18n>Terms &amp; conditions</h4>
  <div class="col-12 mb-3 text-center">
    <button type="button" class="btn btn-primary w-100 d-block" (click)="accept()" i18n>Accept</button>
    <div class="mb-2 mt-2" i18n>or</div>
    <button type="button" class="btn btn-secondary w-100 d-block" (click)="refuse()" i18n>Refuse</button>
  </div>
  <div *ngIf="tnc" class="col-md-12" [innerHTML]="tnc | translateField: 'customer_tnc'"></div>
</form>